export default __webpack_public_path__ + "static/media/q_right_bg.20135177.png";